import React, { useEffect, useState } from 'react';
import { Grid, Layout } from 'antd';
import { useAtom, useAtomValue } from 'jotai';

import {
  KAKAO_REDIRECT_URL,
  SIDE_NAV_WIDTH,
  MAIN_PATH,
} from '@src/constants/constant';
import utils from '@src/utils/utils';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { useLocation, useSearchParams } from 'react-router-dom';

import { Loading } from '@components/shared';
import PhoneNumberModal from '@components/shared/PhoneNumberModal';
import {
  Footer,
  HeaderNav,
  MobileNav,
  PageHeader,
  SideNav,
} from '@components/layout';
import AppRoutes from '@src/layouts/routes/AppRoutes';
import navigationConfig from '@src/layouts/navigation/navigation';
import { NavigationTypes } from '@src/types/types';

import { themeNavCollapsedAtom } from '@src/store/theme';
import { useChannelTalk } from '@hooks/channelTalk/useChannelTalk';
import { authAtom } from '@src/store/auth';
import _ from 'lodash';
import { TeambinderApiService } from '@src/api';
import { useQuery } from '@tanstack/react-query';

const subHeaderUrl = ['/analysis'];
export const AppLayout = () => {
  const [authInfo, setAuthInfo] = useAtom(authAtom);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const location = useLocation();

  if (!authInfo || _.isEmpty(authInfo)) {
    setTimeout(() => {
      window.location.href = '/login';
    }, 500);
  }

  const { data: userResponse } = useQuery(
    ['member'],
    () => TeambinderApiService.getPersonalSettings({}),
    { suspense: false },
  );

  // 로그인 직후 핸드폰 번호 모달 표시
  useEffect(() => {
    if (
      (location.state as any)?.justLoggedIn &&
      userResponse &&
      !userResponse.data?.notification?.kakao?.mobile
    ) {
      setShowPhoneModal(true);
      // state 정리 (새로고침 시 다시 안 뜨도록)
      window.history.replaceState({}, document.title);
    }
  }, [location.state, userResponse?.data]);

  const navCollapsed = useAtomValue(themeNavCollapsedAtom);
  const { pathname } = location;
  const channelTalk = useChannelTalk();
  const currentRouteInfo = utils.getRouteInfo(
    [...navigationConfig],
    pathname,
  ) as NavigationTypes;
  const isMobile = utils.isMobile();
  const getLayoutGutter = () => {
    if (isMobile) {
      return 0;
    }
    return SIDE_NAV_WIDTH;
  };

  const { status } = useThemeSwitcher();

  const isSubHeaderActive = () => {
    const path = location.pathname;
    if (
      path.startsWith('/app/realtime') ||
      path.startsWith('/app/ai-insight') ||
      path.startsWith('/app/ai-report') ||
      path.startsWith('/app/issue-table')
    ) {
      return true;
    }

    let flag = true;
    subHeaderUrl?.map((item) => {
      if (path.includes(item) == false) {
        flag = false;
        return;
      }
    });

    return flag;
  };

  if (status === 'loading') {
    return <Loading cover="page" />;
  }

  return (
    <Layout>
      <PhoneNumberModal
        open={showPhoneModal}
        onCancel={() => setShowPhoneModal(false)}
        onOk={() => setShowPhoneModal(false)}
      />
      <HeaderNav isMobile={isMobile} />
      <Layout className="app-container">
        {!isMobile ? <SideNav /> : null}
        <Layout
          className="app-layout"
          style={{ paddingLeft: getLayoutGutter() }}
        >
          <div className={'app-content-header'}>
            <PageHeader
              display={currentRouteInfo?.breadcrumb}
              title={currentRouteInfo?.title}
            />
          </div>
          <div
            className={`app-sub-content ${
              isSubHeaderActive() ? '' : 'no-sub-header'
            }`}
          >
            <AppRoutes />
          </div>
          <Footer />
        </Layout>
      </Layout>
      {isMobile && <MobileNav routeInfo={currentRouteInfo} />}
    </Layout>
  );
};

export default React.memo(AppLayout);
